module.exports = __webpack_public_path__ + "static/img/1805_5.6ce3ba4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/1805_5.jpg
// module id = gW8y
// module chunks = 1